"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_native_svg_1 = __importStar(require("react-native-svg"));
function SvgComponent(props) {
    return (React.createElement(react_native_svg_1.default, Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none" }, props),
        React.createElement(react_native_svg_1.Path, { d: "M11.645 16c-.758 0-1.616-.197-2.54-.593-1.616-.693-3.365-1.947-4.981-3.53C2.54 10.26 1.287 8.512.594 6.895-.264 4.85-.198 3.167.858 2.112L2.309.66c.891-.89 2.31-.89 3.167 0l1.815 1.815c.429.429.66.99.66 1.583 0 .594-.231 1.155-.66 1.584l-.693.66c.759 1.22 1.781 2.276 3.035 3.035l.693-.66c.857-.858 2.309-.858 3.167 0l1.814 1.814c.43.429.66.99.66 1.584 0 .594-.23 1.154-.66 1.583l-1.451 1.452c-.528.594-1.32.89-2.21.89zM3.893 1.32c-.231 0-.462.099-.66.264L1.781 3.035c-.626.627-.626 1.815.033 3.332.627 1.452 1.782 3.068 3.266 4.553 1.485 1.485 3.101 2.64 4.553 3.266 1.485.627 2.705.66 3.332.033l1.451-1.452a.921.921 0 00.264-.66.921.921 0 00-.264-.66l-1.814-1.814a.936.936 0 00-1.32 0l-1.055 1.023a.645.645 0 01-.792.1c-1.781-.958-3.233-2.442-4.223-4.224-.132-.264-.099-.593.132-.791L6.4 4.718a.921.921 0 00.264-.66.921.921 0 00-.264-.66L4.586 1.584a1.135 1.135 0 00-.693-.264z", fill: "#476EAD" })));
}
exports.default = SvgComponent;
